/**
 * PhotosToggle — feature-local pill button for the Site Status PDF
 * picker's photos on/off control. Adapts the visual feel of
 * src/shared/components/OutdoorToggle.jsx but with light-background-
 * appropriate styling (OutdoorToggle is for the dark rail and uses
 * white-on-dark colors).
 *
 * Per spec section 8.3 + decision lock L20: don't rename OutdoorToggle;
 * a feature-local toggle keeps the picker's coupling explicit.
 */

import React from 'react';
import './PhotosToggle.css';

export default function PhotosToggle({ value, onChange, label = 'Photos' }) {
  const stateClass = value ? 'photos-toggle--on' : 'photos-toggle--off';
  return (
    <button
      type="button"
      className={`photos-toggle ${stateClass}`}
      aria-pressed={value}
      onClick={() => onChange(!value)}
    >
      {label}: {value ? 'On' : 'Off'}
    </button>
  );
}
